import { z } from 'zod';
import {
  timestamp, householdItemType, householdItemState, householdItemRecurrence,
} from '@/lib/schemas/primitives';
import { itemPictureSchema } from '@/features/common/schema';

export const householdItemResponseSchema = z.object({
  id: z.number(),
  householdId: z.number(),
  type: householdItemType,
  title: z.string(),
  state: householdItemState,
  assigneeUserId: z.number().optional(),
  dueDate: timestamp.optional(),
  recurrence: householdItemRecurrence.optional(),
  listId: z.number().optional(),
  categoryId: z.number().optional(),
  parentItemId: z.number().optional(),
  position: z.number(),
  markedAt: timestamp.optional(),
  picture: itemPictureSchema.optional(),
  createdAt: timestamp,
  updatedAt: timestamp,
});
export type HouseholdItemResponse = z.infer<typeof householdItemResponseSchema>;

// POST /household-items body: the item plus a dedupe marker set when the
// create matched an existing same-list item (#479) — 'reopened' (a done copy
// was reopened) or 'existing' (already open; no-op). Absent on a plain create.
export const createHouseholdItemResponseSchema = householdItemResponseSchema.extend({
  dedupe: z.enum(['reopened', 'existing']).optional(),
});
export type CreateHouseholdItemResponse = z.infer<typeof createHouseholdItemResponseSchema>;
